import { Show } from "solid-js";

interface Props {
  ms: number | null | undefined;
  compact?: boolean;
}

type Status = { color: string; glow: string; label: string; title: string };

// Thresholds match ops intuition: green=fast, amber=usable, red=down.
// Colors reuse the existing accent palette so the badge reads as part
// of the app rather than a bolt-on.
function classify(ms: number | null | undefined): Status {
  if (ms == null) {
    return {
      color: "#f44336",
      glow: "rgba(244, 67, 54, 0.6)",
      label: "down",
      title: "Proxy unreachable or not yet probed",
    };
  }
  const rounded = Math.round(ms);
  if (ms < 50) return { color: "#4caf50", glow: "rgba(76, 175, 80, 0.6)", label: `${rounded}ms`, title: "Healthy" };
  if (ms < 200) return { color: "#ffb74d", glow: "rgba(255, 183, 77, 0.6)", label: `${rounded}ms`, title: "Elevated latency" };
  return { color: "#f44336", glow: "rgba(244, 67, 54, 0.6)", label: `${rounded}ms`, title: "High latency" };
}

export default function PingBadge(props: Props) {
  const info = () => classify(props.ms);
  return (
    <span
      title={info().title}
      style={{
        display: "inline-flex",
        "align-items": "center",
        gap: "6px",
        "font-size": props.compact ? "11px" : "12px",
        "font-family": "monospace",
        "font-weight": "bold",
        color: info().color,
        padding: props.compact ? "0" : "2px 8px",
        "border-radius": "var(--radius-sm)",
        background: props.compact ? "transparent" : "rgba(0, 0, 0, 0.2)",
      }}
    >
      <span
        style={{
          width: "8px",
          height: "8px",
          "border-radius": "50%",
          "background-color": info().color,
          "box-shadow": `0 0 6px ${info().glow}`,
          "flex-shrink": "0",
        }}
      />
      <Show when={!props.compact}>{info().label}</Show>
    </span>
  );
}
